export const PERITAJE_PROCESADO = 6;
export const PERITAJE_PENDIENTE_GESTORIA = 9;
export const PERITAJE_USADO_INGRESADO = 11;
export const PERITAJE_VIGENCIA = 30;
export const PERITAJE_PENDIENTE = ["1", "2", "3", "4", "5"];
export const PERITAJE_BUSINESS_UNITS = {
    USADOS: 'Usados',
    NUEVOS: '0km'
}
export const PERITAJE_STATUS = {
    PERITAJE_PENDIENTE: "PERITAJE_PENDIENTE",
    PERITAJE_FINALIZADO: "PERITAJE_FINALIZADO",
    USADO_PENDIENTE_INGRESAR: "USADO_PENDIENTE_INGRESAR",
    USADO_PENDIENTE_GESTORIA: "USADO_PENDIENTE_GESTORIA",
    USADOS_INGRESADO: "USADOS_INGRESADO"
}
